<template>
    <div>
      <el-form label-width="150px" label-position="left" style="margin: 20px;">
      <el-row class="websitequerypanel">
          <el-col :span="24">
            <el-form-item label="OpenId:">
              <el-input
                type="text"
                autosize=""
                placeholder="请输入内容"
                v-model="openid">
              </el-input>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row class="websitequerypanel">
        <el-col :span="24">
          <el-form-item label="标题:">
            <el-input
              type="text"
              autosize=""
              placeholder="请输入标题"
              v-model="title">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述:">
            <el-input
              type="text"
              autosize=""
              placeholder="请输入描述"
              v-model="desc">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="链接：">
            <el-input
              type="text"
              autosize=""
              placeholder="请输入链接"
              v-model="myurl">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="分享图标地址:">
            <el-input
              type="text"
              autosize=""
              placeholder="请输入分享图标地址"
              v-model="imgurl">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row>
          <el-button style="margin-top:20px;" @click="onshare" @touchstart="onshare">分享到朋友圈</el-button>
        </el-row>
      </el-form>
    </div>
</template>

<script>
import Vue from 'vue'
import wx from 'weixin-js-sdk'
import axios from 'axios'
Vue.prototype.$http = axios
var wxinfo = wx
var that
export default {
  name: 'WxShare',
  data () {
    return {
      openid: 'wxb6b6a21ef8474770',
      title: '',
      desc: '',
      mydes: '',
      myurl: '',
      imgurl: '',
      accesstoken: ''
    }
  },
  async mounted () {
    that = this
    that.myurl = window.location.href
    var at = await getaccesstoken()
    that.accesstoken = at
    that.getticket(at)
  },
  methods: {
    getticket (at) {
      var ddata = {
        accesstoken: at,
        url:that.myurl
      }
      window.console.log(ddata)
      that.$http({
        url: 'http://localhost:5009/getticket',
        method: 'post',
        data: ddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          window.console.log(res)
          if (res.data.result === 'success') {
            var tmpdata = res.data
            var sha1sign = tmpdata.sign
            // var timestamp = Date.parse(new Date()).toString()
            // timestamp = timestamp.substr(0,10)
            var noncestr1 = randomWord(false, 30)
            window.console.log(noncestr1)
            var timestamp = tmpdata.timestamp
            var noncestr = tmpdata.nonce
            window.console.log(wxinfo)
            wxinfo.config({
              beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
              appId: that.openid, // 填，企业微信的corpID
              timestamp: timestamp, // 必填，生成签名的时间戳
              nonceStr: noncestr, // 必填，生成签名的随机串 必填，生成签名的随机串
              signature: sha1sign, // 必填，签名
              jsApiList: [
                'onMenuShareTimeline', // 分享朋友圈接口
                'onMenuShareAppMessage' // 分享给朋友接口
              ]
            })
            window.console.log(res)
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    onshare: function () {
      wx.onMenuShareAppMessage({
        title: that.title, // 分享标题
        desc: that.mydes, // 分享描述
        link: that.myurl, // 分享链接
        imgUrl: that.imgurl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        success: function () {
          that.$message.success('分享状态OK')
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          that.$message.info('取消')
          // 用户取消分享后执行的回调函数
        }
      })
    }
  }
}
async function getaccesstoken () {
  return new Promise(resolve => {
    that.$http({
      url: 'https://wx.sqnetsoft.cn/wx/getaccesstoken',
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        window.console.log(res)
        if (res.status === 200) {
          window.console.log(res.data)
          resolve(res.data)
        } else {
          window.console.log('返回错误')
          resolve('')
        }
      })
      .catch(function (error) {
        window.console.log(error)
        resolve('')
      })
  })
}
function randomWord (randomFlag, min, max) {
  var str = ''
  var range = min
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (var i = 0; i < range; i++) {
    var pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wx/WxShare.vue